import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { settingsApi } from '../../../services';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Modal for editing existing users
 */
const EditUserModal = ({ user, onClose, onSuccess, teams, departments }) => {
  const [formData, setFormData] = useState({
    name: user.name,
    role: user.role,
    team_id: user.team_id || '',
    department_id: user.department_id || ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      await axios.patch(`${API}/admin/users/${user.id}`, {
        ...formData,
        team_id: formData.team_id || null,
        department_id: formData.department_id || null
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success('Bruker oppdatert!');
      onSuccess();
      onClose();
    } catch (error) {
      console.error('Failed to update user:', error);
      toast.error(error.response?.data?.detail || 'Kunne ikke oppdatere bruker');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full">
        <div className="p-6 border-b border-slate-200">
          <h2 className="text-2xl font-bold text-slate-900">Rediger bruker</h2>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700 block mb-1">Navn</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              className="w-full px-4 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-slate-500"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-slate-700 block mb-1">Rolle</label>
            <select
              value={formData.role}
              onChange={(e) => setFormData({...formData, role: e.target.value})}
              className="w-full px-4 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-slate-500"
            >
              <option value="LAWYER">Advokat</option>
              <option value="TENANT_ADMIN">Tenant Admin</option>
              <option value="USER">Bruker</option>
            </select>
          </div>

          <div>
            <label className="text-sm font-medium text-slate-700 block mb-1">Team</label>
            <select
              value={formData.team_id}
              onChange={(e) => setFormData({...formData, team_id: e.target.value})}
              className="w-full px-4 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-slate-500"
            >
              <option value="">Ingen team</option>
              {teams.map(team => (
                <option key={team.id} value={team.id}>{team.name}</option>
              ))}
            </select>
          </div>

          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50"
            >
              Avbryt
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 px-4 py-2 bg-slate-900 text-white rounded-lg hover:bg-slate-800 disabled:bg-slate-300"
            >
              {loading ? 'Lagrer...' : 'Lagre'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditUserModal;
